import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import { MENU_FORECAST_ID } from '../../../shared/Config';

class MenuForecast extends Component {
    constructor() {
        super();
        this.state = {
            globalFilter: null,
            selectedCustomers: [],
        };
    }

    componentDidMount() {
        const empId = localStorage.getItem('EmpId');
        this.props.getRequest(empId, MENU_FORECAST_ID);
    }

    statusRender = (rowData) => {
        let status = <Button type="button" label="Pending" className="p-button-warning p-button-rounded" />;
        if (rowData.status === null || rowData.status === undefined) {
            status = <Button type="button" label="Saved as Draft" className="p-button-info p-button-rounded" />;
        } else if (rowData.status === 'Approved' || rowData.status === 'Closed') {
            status = <Button type="button" label={rowData.status} className="p-button-success p-button-rounded" />;
        } else if (rowData.status === 'Canceled' || rowData.status === 'Rejected') {
            status = <Button type="button" label={rowData.status} className="p-button-danger p-button-rounded" />;
        }
        return <div className="actionCenter">{status}</div>;
    }

    renderHeader = () => (
        <div className="p-datatable-globalfilter-container">
            <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search" />
        </div>
    );

    actionTemplate = (rowData) => (
        <div>
            <Link to={{ pathname: `/add-menuforecast/edit/${rowData.requestId}`, state: { ...rowData, editStatus: 'Closed' } }}>
                <Button type="button" icon="pi pi-pencil" className="p-button-info" />
            </Link>
        </div>
    );

    render() {
        const { requestListData } = this.props;
        const data = requestListData && requestListData[0] && requestListData[0].filter(list => list.processId === MENU_FORECAST_ID.toLowerCase() && list.requestFrom === 'My Request') || [];

        return (
            <div className="p-col-12">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                <div className="card card-w-title" style={{ position: 'relative' }}>
                    <h1>Restaurant Menu Forecast</h1>
                    <Link to="/add-menuforecast/add/new" style={{ position: 'absolute', right: '13px', top: '9px' }}>
                        <Button icon="pi pi-plus" label="Menu Forecast" />
                    </Link>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <DataTable
                                value={data}
                                responsive
                                className="p-datatable-customers animated fadeIn"
                                rowHover
                                selection={this.state.selectedCustomers}
                                onSelectionChange={e => this.setState({ selectedCustomers: e.value })}
                                paginator
                                rows={10}
                                emptyMessage="No lists found"
                                globalFilter={this.state.globalFilter}
                                header={this.renderHeader()}>
                                <Column selectionMode="multiple" style={{ width: '3em' }} />
                                <Column field="requestNum" header="Requester No." sortable={true} />
                                <Column field="requesterName" header="Requester Name" style={{ width: '180px' }} />
                                <Column field="requestDate" header="Request Date" sortable={true} />
                                <Column field="remark" header="Remarks" />
                                <Column field="pendingWith" header="Pending With" />
                                <Column field="status" header="Status" body={this.statusRender} sortable={true} />
                                <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loggedUserDetail: state.auth.userObject,
    userPref: state.auth.userPref,
    loading: state.master.loading,
    error: state.master.error,
    requestListData: state.master.requestListData,
});

const mapDispatchToProps = dispatch => ({
    getRequest: (value, processid) => dispatch(actions.getRequest(value, processid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuForecast);
